import _ from 'lodash';
import { IMessage, IDialog, IProgress } from './models';
import { RootState } from '..';

const getNextMessage = (state: RootState): IMessage | undefined =>
	_.first(state.messaging.messages);
const getNextDialog = (state: RootState): IDialog | undefined =>
	_.first(state.messaging.dialogs);
const getProgress = (state: RootState): IProgress | null =>
	state.messaging.progress;

export const selectors = {
	getNextMessage,
	getNextDialog,
	getProgress
};
